<template>
  <div class="bg-white dark:bg-gray-900 text-blue-700 dark:text-indigo-300 placeholder-blue-400 dark:placeholder-indigo-500 min-h-screen font-sans">
    <div class="mx-auto">
      <router-view/>
      <p class="text-center py-8">
        Hecho con <font-awesome-icon :icon="['fas', 'heart']" title="amor" class="fill-current text-red-600"/> por <strong>Pablo Martínez</strong>
      </p>
    </div>
  </div>
</template>
